import * as React from 'react';
import { WithChildrenProps } from '..';
import { withAuditLabel, WithAuditLabelProps } from './withAuditLabel';

export interface AuditLabelProps extends WithAuditLabelProps, WithChildrenProps {
    controller: string;
    action: string;
    fieldName: string;
}

class AuditLabel extends React.Component<AuditLabelProps> {
    render() {
        const { children, controller, action, fieldName, al } = this.props;
        const result = al(controller, action, fieldName);
        return !result.includes(`[${fieldName}]`) ? result : (children || result);
    }
}

export default withAuditLabel<AuditLabelProps>()(AuditLabel);